import FieldsModel from '@/Models/Contracts/FieldsModel';
import Budget from '@/Models/Budget';
import i18n from '@/Plugins/i18n';
export default class BudgetEntry extends FieldsModel {
    resource() {
        return 'budget-entries';
    }
    relations() {
        return {
            budget: Budget
        };
    }
    get header() {
        return `
            <span class="grid gap-2">
                <span>${i18n.t('general.budget')}</span>
                <span>${moment(this.date).format('MMMM YYYY')}</span>
            </span>
        `;
    }
}
